<script setup>
import { ref, watch } from 'vue';

const props = defineProps({
  title: { type: String, required: true },
  description: { type: String, default: '' },
  isOpen: { type: Boolean, default: false },
  icon: { type: String, default: '' },
});

const isExpanded = ref(props.isOpen);

const toggleAccordion = () => {
  isExpanded.value = !isExpanded.value;
};

watch(
  () => props.isOpen,
  newValue => {
    isExpanded.value = newValue;
  }
);
</script>

<template>
  <div class="border rounded-lg border-n-slate-4">
    <button
      class="flex items-center justify-between w-full p-4 text-left"
      @click="toggleAccordion"
    >
      <div class="flex items-center">
        <span v-if="icon" :class="icon" class="w-5 h-5 mr-2" />
        <div class="flex flex-col">
          <span class="text-sm font-medium text-n-slate-12">{{ title }}</span>
          <span v-if="description" class="text-xs text-n-slate-10 mt-0.5">{{
            description
          }}</span>
        </div>
      </div>
      <span
        class="w-5 h-5 transition-transform duration-200 i-lucide-chevron-down"
        :class="{ 'rotate-180': isExpanded }"
      />
    </button>
    <div v-if="isExpanded" class="p-4 pt-0">
      <slot />
    </div>
  </div>
</template>
